export default __webpack_public_path__ + "static/media/donchanin.44ed5886.png";